module.exports = __webpack_public_path__ + "img/application.49f617f3.svg";